// src/useTagManager.ts
import { ref } from "vue";
var initialized = ref(false);
var GTM_BASE_URL = "https://www.googletagmanager.com/gtm.js";
var dataLayer = window.dataLayer = window.dataLayer || [];
var push = (eventData) => {
  dataLayer.push(eventData);
};
var init = (brokerId, isAdmin, gtmId, additionalDataLayerDefaults) => {
  if (gtmId === void 0) {
    console.warn("missing GTM_ID process .env");
    return;
  }
  if (initialized.value)
    return;
  const existingScript = document.querySelector(`script[data-ccm-loader-src*="${GTM_BASE_URL}?id=${gtmId}"]`);
  if (existingScript)
    return;
  window.dataLayer = window.dataLayer || [];
  dataLayer = window.dataLayer;
  if (brokerId !== "guest") {
    dataLayer.push({ brokerId });
  }
  dataLayer.push({ isAdmin });
  if (additionalDataLayerDefaults) {
    dataLayer.push(additionalDataLayerDefaults);
  }
  dataLayer.push({ "gtm.start": (/* @__PURE__ */ new Date()).getTime(), "event": "gtm.js" });
  const target = document.getElementsByTagName("script")[0];
  const script = document.createElement("script");
  script.type = "text/x-ccm-loader";
  script.setAttribute("data-ccm-loader-src", `${GTM_BASE_URL}?id=${gtmId}`);
  script.setAttribute("data-ccm-loader-group", "ga");
  target?.parentNode?.insertBefore(script, target);
};
var useTagManager = () => ({
  push,
  init
});
export {
  useTagManager
};
